import { render, staticRenderFns } from "./ShTelInput.vue?vue&type=template&id=58aa133e&scoped=true&"
import script from "./ShTelInput.vue?vue&type=script&lang=js&"
export * from "./ShTelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa133e",
  null
  
)

export default component.exports